<template>
  <div class="div-selector">
    <v-btn-toggle v-model="selectedItem" :disabled="disabled" mandatory>
      <v-btn :disabled="disabled" @click="selectedMine">
        Mine
      </v-btn>
      <v-btn v-if="selectedTreeviewText !== ''" variant="tonal">
        {{ selectedTreeviewText }}
      </v-btn>
      <v-btn :disabled="disabled" @click="dialog = true">
        ...
      </v-btn>
    </v-btn-toggle>

    <v-dialog v-model="dialog" scrollable width="500">
      <v-card height="500">
        <v-card-title class="text-h5 grey lighten-2">
          Select Filter
        </v-card-title>
        <v-card-text>
          <v-treeview
            activatable
            :items="items2.data"
            item-key="key"
            item-text="title"
            @update:active="selectItemChange"
          ></v-treeview>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="selectItem">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { getSessionKey } from '@helpers/browser-storage'
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultkey: {
      type: String,
      default: '',
    },
    task: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedTreeviewText: '',
      selectedTreeviewKey: '',
      dialog: false,
      selectedItem: 0,
      items2: { data: [] },
      items: [
        {
          id: 1,
          name: 'Global',
          children: [
            { id: 2, name: 'Australia' },
            { id: 3, name: 'New Zealand' },
            { id: 4, name: 'United Kingdom' },
            {
              id: 5,
              name: 'USA',
              children: [
                { id: 6, name: 'State 1' },
                { id: 7, name: 'State 2' },
              ],
            },
          ],
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      divisionList: 'staff/divTree',
    }),
  },
  created() {
    this.selectedTreeviewKey = []

    if (getSessionKey('candidate-guaranteed-filter') !== null) {
      var item = getSessionKey('candidate-guaranteed-filter')
      this.selectedTreeviewKey.push(item.id + '-' + item.level)
    }

    this.loadDivisionList().then((response) => {
      this.items2.data = response.data
      this.refreshControl()
    })
  },
  methods: {
    ...mapActions({
      loadDivisionList: 'staff/loadDivisionTree',
      returnDivisionTreeItemByKey: 'staff/returnDivisionTreeItemByKey',
    }),
    selectedMine: function() {
      this.selectedTreeviewText = ''
      this.$emit('changed-division', { type: 'mine', id: -1 })
    },
    selectItemChange: function(i) {
      this.selectedTreeviewKey = i
    },
    refreshControl: function() {
      // lookup friendly title by key
      this.returnDivisionTreeItemByKey(this.selectedTreeviewKey[0]).then(
        (response) => {
          if (this.selectedTreeviewKey[0] !== 'Mine') {
            this.selectedItem = 2
          }
          this.selectedTreeviewText = response?.data?.title
        }
      )
    },
    selectItem: function() {
      this.refreshControl()

      var treeview = this.selectedTreeviewKey[0].split('-')
      this.$emit('changed-division', { type: treeview[1], id: treeview[0] })
      this.dialog = false
    },
  },
}
</script>

<style scoped lang="scss">
.div-selector {
  margin-bottom: 20px;
}
</style>
